import useCmsQuery from './useCmsQuery.tsx';
import { getApiErrors, TErrorContent } from '../../cms';
import useMarketInfo from '../../hooks/useMarketInfo';

export type { TErrorContent };

const useFetchErrorContent = (
  key: string | null | undefined,
  options?: { skip?: boolean },
): { data: TErrorContent | undefined; loading: boolean; fallbackTitle?: string } => {
  const { language } = useMarketInfo();

  const { data, loading } = useCmsQuery(
    () => getApiErrors({ language, key: key ?? '' }),
    [language, key],
    { skip: options?.skip || !key },
  );

  return {
    data:          data?.content,
    loading,
    fallbackTitle: data?.fallbackTitle,
  };
};

export default useFetchErrorContent;
